// extracted by mini-css-extract-plugin
module.exports = {"lazy":"styles_lazy__k0t5z","mobile":"styles_mobile__9XBbZ","desktop":"styles_desktop__Oy5Wk","caption":"styles_caption__716Yq"};